module.exports = __webpack_public_path__ + "static/media/home1.7ed9ca46.svg";